import React from 'react';
import {z} from 'zod';

import {NotesOutlined} from '@mui/icons-material';

import {RichText,RichTextPropsSchema} from './RichText';
import RichTextSidebarPanel from './RichTextSidebarPanel';

export type RichTextProps = z.infer<typeof RichTextPropsSchema>;

export default {
    label: 'RichText',
    icon: <NotesOutlined />,
    type: 'RichText',
    defaultData: {
        props: { text: '<p>Rich Text <strong>Content</strong></p>' },
        style: {
            padding: { top: 16, bottom: 16, left: 24, right: 24 },
            fontWeight: 'normal',
            fontSize: 16,
        },
    },
    SidebarPanel: RichTextSidebarPanel,
    Component: RichText,
    schema: RichTextPropsSchema,
};